import { useParams } from 'react-router-dom';
import NewQuotePage from '../../new/page';

export default function EditQuotePage() {
  const { id } = useParams<{ id: string }>();
  return <NewQuotePage editQuoteId={id || null} />;
}